import { render, staticRenderFns } from "./ProyectoNew.vue?vue&type=template&id=37e08f07&scoped=true&"
import script from "./ProyectoNew.vue?vue&type=script&lang=js&"
export * from "./ProyectoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e08f07",
  null
  
)

export default component.exports